import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import { useAppDispatch } from "../../hooks/hooks";
import { useGetFacultiesQuery } from "../../hooks/useGetFacultiesQuery";
import { setUpdateFacultyData } from "../../redux/slices/school/faculty";
import { routes } from "../../routes";
import { updateFaculty } from "../../services/school/faculty/updateFaculty";
import { FacultyType } from "../../types/Faculty";
import { setPreviousPath } from "../../redux/slices/previousPath";

const columnNamesMap: { [key: string]: string } = {
    description: 'Nome',
};
export default function Faculties() {
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const queryClient = useQueryClient();
    const { data, status } = useGetFacultiesQuery({ PageNumber: currentPage, PageSize: 400 });

    const mutationUpdateFaculty = useMutation(updateFaculty, {
        onSuccess: () => {
            queryClient.invalidateQueries('faculties-pagination');
            toast.success('Unidade orgânica apagada com sucesso');
        },
        onError: () => {
            toast.error("Erro ao apagar Unidade orgânica.")
        }
    });

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handleClickCreate = (event: any): void => {
        navigate(routes.createFaculty)
    }
    const handleEdit = (faculty: FacultyType) => {
        dispatch(setUpdateFacultyData(faculty));
        navigate(routes.updateFaculty)
    };
    const handleDelete = (faculty: FacultyType) => {
        faculty.status = false;
        mutationUpdateFaculty.mutateAsync(faculty)
    };
    const handleAssignManagers = (faculty: FacultyType) => {
        dispatch(setUpdateFacultyData(faculty));
        dispatch(setPreviousPath(routes.faculties))
        navigate(routes.assignManager)

    };

    const options = data?.items.map((faculty: FacultyType) => [
        {
            label: 'Editar',
            onClick: (role: FacultyType) => handleEdit(faculty),
            icon: <Pencil1Icon />
        },
        {
            label: 'Vincular responsável',
            onClick: () => handleAssignManagers(faculty),
            icon: <Pencil1Icon />
        },
        {
            label: 'Excluir',
            onClick: () => handleDelete(faculty),
            icon: <TrashIcon />
        },
    ]) || [];

    return (
        <Lists
            status={status}
            TableComponent={() =>
                <TableComponent
                    columns={Object.keys(columnNamesMap)}
                    items={data?.items}
                    options={options}
                    columnNamesMap={columnNamesMap}
                    totalPages={data?.totalPages || 1}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                />
            }
            handleClickCreate={handleClickCreate}
        />
    );
}